export default {
    bindings: {
        timeframe: '@',
        loading: '<',
        callback: '&',
        orders: '<',
    },
    controller: 'orderHistoryPaginationController',
    template: require('../views/order.history.pagination.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/user/components/order.history.pagination.component.js